import { createFileRoute } from '@tanstack/react-router'

import { ClassEditView } from '@/modules/classes'

export const Route = createFileRoute(
  '/_auth/students-and-classes/classes/edit/$classId'
)({
  component: ClassEditView
})
